export default __webpack_public_path__ + "static/media/icon_heart.8ee2faa2.svg";